export default "__VITE_ASSET__DAFmB9wF__"